import React from "react";
import Items from "./Components/Items";

const App = () => {
  return <Items/>
}
export default App;